<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZDthLf/tc-custom/9781466853997.jpg?1721429486358" alt="This image is the cover for the book Islands of Silence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Islands of Silence
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Islands of Silence</i> is the story of the young Alec Marquand, who in the summer of 1914 has just graduated from college with a degree in archaeology. He has been hired by the lord of a remote country estate in the Scottish Highlands to survey the ancient Stone Age brochs that lie on his property. <br/><br/>Once there Alec comes upon a small island which is called Eilean Tosdach--the Island of Silence.  What Alec discovers on that island changes him forever. And just as Alec makes his amazing find, he is shipped off to war . . . a war he does not want to fight, but one in which he ends up as a medic aboard a ship ready to storm the beaches of Gallipoli.<br/><br/>A brilliantly crafted novel in the tradition of <i>All's Quiet on the Western Front </i>and <i>The Ghost Road, Islands of Silence</i> is a tour through one man's hell in search of a path for redemption.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Booth
      </h2>
      
      <p class="authorDescription body article"><P><B>Martin Booth</B> (1944-2004) was the bestselling author of novels including <I>Hiroshima Joe</I>, <I>Islands of Silence</I>, and <I>The Industry of Souls</I>, which was shortlisted for the Booker Prize. Another novel, <I>A Very Private Gentlemen</I>, was adapted into the 2010 movie, The American, starring George Clooney. He also wrote several nonfiction books, including<I> Cannabis: A History</I> and the memoir <I>Golden Boy: Memories of a Hong Kong Childhood</I>. Booth was born in England, but spent much of his childhood in Hong Kong, a location that would deeply inspire his writing. He moved back to England at the age of 20, and started his literary career as a poet. He worked as a schoolmaster, a job he held until 1985, when the success of <I>Hiroshima Joe</I> allowed him to devote himself full-time to his writing. At the time of his death in 2004, he was living in Devon, England.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4dcee6c5